<template>
    <div class="d-flex align-items-center justify-content-between" :style="{ gap: '20px' }">
        <div class="d-flex align-items-center" :style="{ gap: '12px' }">
            <div class="d-flex align-items-center" :style="{ gap: '12px' }">
                <el-input
                    v-model="filters.search"
                    size="small"
                    placeholder="Código ou nome"
                    prefix-icon="el-icon-search"
                    clearable
                    :style="{ width: '375px' }"
                    @keyup.enter.native.prevent="setFilters()"
                />

                <el-button
                    size="small" 
                    type="primary"
                    circle
                    @click="setFilters()"
                >
                    <i class="el-icon-search"></i>
                </el-button>
            </div>

            <FilterBuilder @apply="setFilters">
                <template slot="list">
                    <FilterBuilderDateRange title="Período" icon="el-icon-date" v-model="filters.periodo"/>
                    <FilterBuilderSelect title="Situação" icon="el-icon-circle-check" v-model="filters.status" :options="status" />
                    <FilterBuilderSelect
                        title="Classes"
                        icon="el-icon-files"
                        v-model="filters.classe"
                    >
                        <el-option
                            v-for="classe in classes"
                            :key="classe.value"
                            :label="classe.text"
                            :value="classe.value"
                        />
                    </FilterBuilderSelect>
                    <FilterBuilderSelect
                        title="UFs"
                        icon="el-icon-location-outline"
                        v-model="filters.estado"
                        @change="onUfChange"
                    >
                        <el-option
                            v-for="uf in ufs"
                            :key="uf.uf"
                            :label="uf.nome"
                            :value="uf.uf"
                        >
                        </el-option>
                    </FilterBuilderSelect>
                    <FilterBuilderSelect
                        ref="cidadeFilter"
                        title="Cidade"
                        icon="el-icon-location-outline"
                        v-model="filters.cidade"
                        :disabled="!ufSelecionada"
                        tooltip
                        tooltip-text="Selecione uma UF para habilitar a escolha da cidade."
                    >
                        <el-option
                            v-for="city in cities"
                            :key="city.id"
                            :label="city.nome"
                            :value="city.id"
                        />
                    </FilterBuilderSelect>
                </template>
            </FilterBuilder>

            <ExcelExport :request="exportRequest" file-name="distribuidores" placement="bottom-start">
                <template #header>
                    <ExcelHeaderColumn title="Código" value="codigo" />
                    <ExcelHeaderColumn title="Nome" value="nome" />
                    <ExcelHeaderColumn title="Classe" value="classe"/>
                    <ExcelHeaderColumn title="Status" value="status"/>
                    <ExcelHeaderColumn title="Cidade" value="cidade" />
                    <ExcelHeaderColumn title="Estado" value="uf" />
                    <ExcelHeaderColumn title="Criado em" value="created_at" :callback="v => v ? formatDate(v) : 'Não informado'"/>
                </template>

                <template #filters="{ filters }">
                    <FilterBuilder inline auto-apply>
                        <template #list>
                            <FilterBuilderSelect title="Situação" icon="el-icon-circle-check" v-model="filters.status" :options="status" />
                            <FilterBuilderSelect
                                title="Classe"
                                icon="el-icon-files"
                                v-model="filters.classe"
                            >
                                <el-option
                                    v-for="classe in classes"
                                    :key="classe.value"
                                    :label="classe.text"
                                    :value="classe.value"
                                />
                            </FilterBuilderSelect>

                            <FilterBuilderSelect
                                title="Estado"
                                icon="el-icon-location-outline"
                                v-model="filters.estado"
                                @change="onUfChange"
                            >
                                <el-option
                                    v-for="uf in ufs"
                                    :key="uf.uf"
                                    :label="uf.nome"
                                    :value="uf.uf"
                                >
                                </el-option>
                            </FilterBuilderSelect>

                            <FilterBuilderSelect
                                ref="cidadeFilter"
                                title="Cidade"
                                icon="el-icon-location-outline"
                                v-model="filters.cidade"
                                :disabled="!ufSelecionada"
                                tooltip
                                tooltip-text="Selecione uma UF para habilitar a escolha da cidade."
                            >
                                <el-option
                                    v-for="city in cities"
                                    :key="city.id"
                                    :label="city.nome"
                                    :value="city.id"
                                />
                            </FilterBuilderSelect>
                        </template>
                    </FilterBuilder>
                </template>
            </ExcelExport>
        </div>

        <div class="d-flex justify-content-end">
            <el-dropdown size="mini" split-button plain @command="handleSetOrder">
                <strong>Ordernar</strong>: {{ filters.orderBy == 'latest' ? 'Recentes' : 'Antigos' }}
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="latest">
                        <div class="d-flex align-items-center">
                            <i class="el-icon-top mr-2"></i>
                            Mais Recentes
                        </div>
                    </el-dropdown-item>
                    <el-dropdown-item command="oldest">
                        <div class="d-flex align-items-center">
                            <i class="el-icon-bottom mr-2"></i>
                            Mais Antigos
                        </div>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
    import {
        Dropdown,
        DropdownMenu,
        DropdownItem,
        Button,
        Row, 
        Col,
        Select,
        Option,
        Notification,
    } from 'element-ui';
    
    import { FilterBuilder, FilterBuilderSelect, FilterBuilderInput, FilterBuilderDateRange } from '@/components/_micro/FilterBuilder/_index';

    import ExcelExport from "@/components/_micro/Excel/ExcelExport.vue";
    import ExcelHeaderColumn from "@/components/_micro/Excel/ExcelHeaderColumn.vue";

    // Utils
    import { formatDate, formatCPF } from "@/util/formatters";

    // Api
    import { DistribuidorApi } from "@/api/DistribuidorApi.js";
    import { GeneralResourcesApi } from "@/api/GeneralResourcesApi"; 

    const generalResourcesApi = new GeneralResourcesApi();
    const distribuidorApi = new DistribuidorApi();

    export default {
        data() {
            return {
                filters: {
                    search: '',
                    distribuidor: null,
                    classe: null,
                    status: null,
                    estado: null,
                    cidade: null,
                    periodo: [],
                    orderBy: 'latest',
                },
                status: [
                    { value: '1', label: 'Ativo' },
                    { value: '2', label: 'Inativo' },
                    { value: '3', label: 'Inadimplente' },
                ],
                cities: [],
                ufs: [],
                classes: [],
                // UF escolhida no rascunho do filtro (antes de "Aplicar")
                ufSelecionada: null,
            }
        },
        methods: {
            async getUfs() {
                try {
                    this.isLoading = true;

                    const res = await generalResourcesApi.pluckUfs();

                    this.ufs = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter seu estado(UF)!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async getCities(uf) {
                if (!uf) {
                    this.cities = [];
                    return;
                }

                try {
                    this.isLoading = true;

                    const res = await generalResourcesApi.pluckCities(uf);

                    this.cities = res;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter as cidades!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            getClasses() {
                this.classes = [
                    { value: '', text: 'Todas' },
                    { value: 'A', text: 'A' },
                    { value: 'G', text: 'G' },
                    { value: 'V', text: 'V' },
                    { value: 'L', text: 'L' },
                    { value: 'P', text: 'P' },
                    { value: 'B', text: 'B' },
                    { value: 'D', text: 'D' },
                ];
            },
            /** UF mudou no filtro: limpa a cidade e recarrega a lista */
            onUfChange(uf) {
                if (uf === this.ufSelecionada) return;
                this.ufSelecionada = uf;

                const cidade = this.$refs.cidadeFilter;
                if (cidade) cidade.draft = cidade.getEmptyValue();

                this.getCities(uf);
            },
            /**Filters */
            async handleSetOrder(orderBy) {
                this.filters.orderBy = orderBy;
                this.setFilters();
            },
            setFilters() {
                this.$emit('filtered', {...this.filters});
            },
            /**Excel */
            async exportRequest(params) {
                return distribuidorApi.list(params);
            },
            formatDate,
            formatCPF
        },
        computed: {
            getDistributor() {
                return this.$store.getters['user/getDistributor']()
            }
        },  
        watch: {
            "filters.search": {
                handler(_newValue, _oldValue) {
                    if(_newValue == '' || _newValue == null) {
                        this.$emit('filtered', {...this.filters});
                    }
                    return;
                },
            }
        },
        async mounted() {
            await this.getUfs();
            this.getClasses();
        },
        components: {
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            [Notification.name]: Notification,
            [Row.name]: Row,
            [Col.name]: Col,
            [Button.name]: Button,
            [Select.name]: Select,
            [Option.name]: Option,
            FilterBuilder,
            FilterBuilderSelect,
            FilterBuilderInput,
            FilterBuilderDateRange,
            ExcelExport,
            ExcelHeaderColumn
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_internal/distribuidor/DistribuidorFilter.vue